import React from 'react';

type Props = {} & React.SVGProps<SVGSVGElement>;

const SvgSmileyTerrible = (props: Props): JSX.Element => {
  return (
    // @ts-ignore
    <svg
      viewBox="0 0 35 35" {...props}
    >
      <path
        className={'path'}
        d="M17.5.247C7.972.247.247 7.972.247 17.5S7.971 34.753 17.5 34.753 34.753 27.028 34.753 17.5 27.028.247 17.5.247zm8.347 12.836a3.219 3.219 0 11-6.438 0c0-.168.017-.332.042-.493 2.025-.381 3.717-1.297 4.961-2.185a3.211 3.211 0 011.435 2.678zM15.591 12.8a3.219 3.219 0 11-6.438 0c0-1.05.505-1.98 1.283-2.567 1.668 1.238 3.388 2.025 5.145 2.357.004.069.01.139.01.21zm11.088 13.451a1.173 1.173 0 01-1.664 0c-2.55-2.55-5.191-3.787-7.849-3.679-4.147.169-7.084 3.572-7.113 3.607a1.177 1.177 0 01-1.799-1.517c.144-.172 3.602-4.217 8.791-4.441 3.358-.145 6.593 1.324 9.635 4.366.458.46.458 1.205-.001 1.664z"
      />
    </svg>
  );
};

export default SvgSmileyTerrible;
